<template>
  <div data-component="PeerView" class="peer-view">

    <div class="my-screen-overlay" v-if="myScreenShare">
      <i v-if="screenShare" class="fa fa-desktop" aria-hidden="true"></i>
    </div>

    <div class="info" :class="videoTrack == null ? 'disable-video' : ''">
      <div class="peer" :class='screenShare ? "screen-cast-item" : ""'>
        <div class="display-name-container">
          <span class="display-name" v-if="!myScreenShare">
            <i v-if="screenShare" class="fa fa-desktop" aria-hidden="true"></i>
            <span class="name">
              <span class="first-name">{{ peer.displayName }}</span>
              <span v-if="peer.title" class="title">{{ peer.title }}</span>
            </span>
            <span v-if="screenShare" class="screen-share-span">paylaşıyor</span>
          </span>
          <span class="display-name" v-if="myScreenShare">
            <i v-if="screenShare" class="fa fa-desktop" aria-hidden="true"></i> Şu anda ekranınızı paylaşıyorsunuz...
          </span>
          <span v-if="myScreenShare" @click="onDisableShareClick" class="close-screenshare">Paylaşımı durdur</span>
        </div>

      </div>

    </div>

    <video
      class="peer-video"
      ref="videoElem"
      :class="{ 'is-me': isMe, hidden: !videoVisible || !videoCanPlay, 'network-error': videoVisible && videoMultiLayer && consumerCurrentSpatialLayer === null }"
      autoPlay
      playsInline
      :id="'video-' + peer.id + (screenShare ? '-s' : '')"
      :controls="false"
    />

    <audio ref="audioElem"  autoPlay  :controls="false" :id="'audio-' + peer.id + (screenShare ? '-s' : '')" />

<!--    <canvas ref="canvas" class="face-detection" :class="{ 'is-me': isMe }" />-->

    <div class="volume-container">
      <div class="bar" :class="`level${audioVolume}`" />
    </div>

    <div v-if="videoElemPaused">
      <div class="video-elem-paused" />
    </div>

  </div>
</template>

<script>
import hark from 'hark'
import peerViewProps from '../PeerView/PeerViewProps'
export default {
  props: peerViewProps,
  data() {
    return {
      calcVideoWidthh:null,
      audioVolume: 0, // Integer from 0 to 10.,
      showInfo: window.SHOW_INFO || false,
      videoResolutionWidth: null,
      videoResolutionHeight: null,
      videoCanPlay: false,
      videoElemPaused: false,
      maxSpatialLayer: null,

      hark: null,
      p_videoTrack: null,
      p_audioTrack: null,
      videoResolutionPeriodicTimer: null,
      faceDetectionRequestAnimationFrame: null,
    }
  },
  computed: {
    getCurrentSession() {
      return this.$store.state.sessions.find(
        k => k.id == this.$route.params.session_id
      );
    },
    me() {
      return this.$store.state.me
    },
    sortedAudioScores() {
      const score = this.audioScore
      const scores = Array.isArray(score) ? score : [score]

      return scores.sort((a, b) => {
        if (a.rid) return a.rid > b.rid ? 1 : -1
        else return a.ssrc > b.ssrc ? 1 : -1
      })
    },
    sortedVideoScores() {
      const score = this.videoScore
      const scores = Array.isArray(score) ? score : [score]

      return scores.sort((a, b) => {
        if (a.rid) return a.rid > b.rid ? 1 : -1
        else return a.ssrc > b.ssrc ? 1 : -1
      })
    }
  },
  watch: {
    audioMuted() {
      this.$refs.audioElem.muted = this.isMe || this.audioMuted
    },
    audioTrack() {
      this._updateTracks(this.audioTrack, this.videoTrack)
    },
    videoTrack() {
      this._updateTracks(this.audioTrack, this.videoTrack)
    },
    videoRtpParameters() {
      this._updateTracks(this.audioTrack, this.videoTrack)
    }
  },
  mounted() {
    this.$nextTick(function() {
      this.$refs.videoElem.muted = true
      this.$refs.audioElem.muted = this.isMe || this.audioMuted

      this.setTracks(this.audioTrack, this.videoTrack);
      this.calcVideoWidth();
    })
  },
  beforeMount() {
    this.calcVideoWidth();

    window.addEventListener('resize', () => {
      this.calcVideoWidth();
    });
  },
  beforeDestroy() {
    clearInterval(this.videoResolutionPeriodicTimer);
  },
  methods: {

    calcVideoWidth() {
      var width = 0;
      var height = 0;
      var windowWidth = window.innerWidth - 400;
      var windowHeight = window.innerWidth - 155;

      if(this.$store.state.consumers.length != 0) {
        width = windowWidth / this.$store.state.consumers.length;
        height = windowHeight / this.$store.state.consumers.length;
        //alert(width);
        this.calcVideoWidthh = "width: " + width + "px; max-width: " + width + "px; height:" + height + "px;";
      }

      //$store.state.consumers.length
    },
    _updateTracks(audioTrack, videoTrack) {
      if (
        this.isMe &&
        this.videoRtpParameters &&
        this.maxSpatialLayer === null
      ) {
        this.maxSpatialLayer = this.videoRtpParameters.encodings.length - 1
      } else if (
        this.isMe &&
        !this.videoRtpParameters &&
        this.maxSpatialLayer !== null
      ) {
        this.maxSpatialLayer = null
      }

      this.setTracks(audioTrack, videoTrack)
    },
    setTracks(audioTrack, videoTrack) {
      if (this.p_audioTrack === audioTrack && this.p_videoTrack === videoTrack)
        return

      this.p_audioTrack = audioTrack
      this.p_videoTrack = videoTrack

      if (this._hark) {
        this._hark.stop()
      }

      this._stopVideoResolution()

      if (this.faceDetection) {
        this._stopFaceDetection()
      }

      const { audioElem, videoElem } = this.$refs

      if (audioTrack) {
        const stream = new MediaStream()
        localStream.addTrack(audioTrack)
        stream.addTrack(audioTrack)
        audioElem.srcObject = stream

        audioElem
          .play()
          .catch((error) => console.warn('audioElem.play() failed:%o', error))

        this._runHark(stream)
      } else {
        audioElem.srcObject = null
      }
      if (videoTrack) {
        const stream = new MediaStream()
        localStream.addTrack(videoTrack)
        stream.addTrack(videoTrack)
        videoElem.srcObject = stream
        videoElem.oncanplay = () => {
          this.videoCanPlay = true
        }

        videoElem.onplay = () => {
          this.videoElemPaused = false

          audioElem
            .play()
            .catch((error) => console.warn('audioElem.play() failed:%o', error))
        }

        videoElem.onpause = () => {
          this.videoElemPaused = true
        }

        videoElem
          .play()
          .catch((error) => console.warn('videoElem.play() failed:%o', error))

        this._startVideoResolution()

        if (this.faceDetection) {
          this._startFaceDetection()
        }
      } else {
        videoElem.srcObject = null
      }
    },
    _printConsumerScore(id, score) {
      return `score:${score.score}, producerScore:${score.producerScore}`
    },
    _startVideoResolution() {
      const $this = this
      this.videoResolutionPeriodicTimer = setInterval(() => {
        const { videoElem } = $this.$refs

        if (
          videoElem !== undefined &&
          (videoElem.videoWidth !== $this.videoResolutionWidth ||
            videoElem.videoHeight !== $this.videoResolutionHeight)
        ) {
          $this.videoResolutionWidth = videoElem.videoWidth
          $this.videoResolutionHeight = videoElem.videoHeight
        }
      }, 500)
    },
    _runHark(stream) {
      if (!stream.getAudioTracks()[0])
        throw new Error('_runHark() | given stream has no audio track')

      this.hark = hark(stream, { play: false })

      // eslint-disable-next-line no-unused-vars
      this.hark.on('volume_change', (dBs, threshold) => {
        // The exact formula to convert from dBs (-100..0) to linear (0..1) is:
        //   Math.pow(10, dBs / 20)
        // However it does not produce a visually useful output, so let exagerate
        // it a bit. Also, let convert it from 0..1 to 0..10 and avoid value 1 to
        // minimize component renderings.
        let audioVolume = Math.round(10 ** (dBs / 85) * 10)

        if (audioVolume === 1) audioVolume = 0

        if (audioVolume !== this.audioVolume) {
          this.audioVolume = audioVolume
        }
      })
    },
    _stopFaceDetection() {
      cancelAnimationFrame(this.faceDetectionRequestAnimationFrame)

      const { canvas } = this.$refs

      canvas.width = 0
      canvas.height = 0
    },
    _stopVideoResolution() {
      clearInterval(this.videoResolutionPeriodicTimer)

      this.videoResolutionWidth = null
      this.videoResolutionHeight = null
    },
    onClickDownSpatialLayer() {
      const newMaxSpatialLayer = this.maxSpatialLayer - 1

      this.$emit('onChangeMaxSendingSpatialLayer', newMaxSpatialLayer)
      this.maxSpatialLayer = newMaxSpatialLayer
    },

    onClickUpSpatialLayer() {
      const newMaxSpatialLayer = this.maxSpatialLayer + 1

      this.$emit('onChangeMaxSendingSpatialLayer', newMaxSpatialLayer)
      this.maxSpatialLayer = newMaxSpatialLayer
    },

    onClickDownVideoPreferredLayers() {
      let newPreferredSpatialLayer = this.consumerPreferredSpatialLayer
      let newPreferredTemporalLayer

      if (this.consumerPreferredTemporalLayer > 0) {
        newPreferredTemporalLayer = this.consumerPreferredTemporalLayer - 1
      } else {
        if (this.consumerPreferredSpatialLayer > 0)
          newPreferredSpatialLayer = this.consumerPreferredSpatialLayer - 1
        else newPreferredSpatialLayer = this.consumerSpatialLayers - 1

        newPreferredTemporalLayer = this.consumerTemporalLayers - 1
      }

      this.$emit(
        'onChangeVideoPreferredLayers',
        newPreferredSpatialLayer,
        newPreferredTemporalLayer
      )
    },

    onClickUpVideoPreferredLayers() {
      let newPreferredSpatialLayer = this.consumerPreferredSpatialLayer
      let newPreferredTemporalLayer

      if (
        this.consumerPreferredTemporalLayer <
        this.consumerTemporalLayers - 1
      ) {
        newPreferredTemporalLayer = this.consumerPreferredTemporalLayer + 1
      } else {
        if (this.consumerPreferredSpatialLayer < this.consumerSpatialLayers - 1)
          newPreferredSpatialLayer = this.consumerPreferredSpatialLayer + 1
        else newPreferredSpatialLayer = 0

        newPreferredTemporalLayer = 0
      }

      this.$emit(
        'onChangeVideoPreferredLayers',
        newPreferredSpatialLayer,
        newPreferredTemporalLayer
      )
    },
    onDisableShareClick() {
      this.$emit('onDisableShareClick')
    },
    onStatsClick() {
      if (this.isMe) {
        this.$emit('onStatsClick', this.me.id)
      } else {
        this.$emit('onStatsClick', this.peer.id)
      }
    },
    onClickRequestKeyframe() {
      this.$emit('onRequestKeyFrame')
    },
    onChangeVideoPriority(priority) {
      this.$emit('onChangeVideoPriority', priority)
    }
  }
}
</script>

<style lang="less">
.screen-cast-bottom-wrapper {
  .peer-view {
    .info {
      .peer {
        padding: 1px 6px !important;
      }
    }
  }
}

.peer-view {
  .my-screen-overlay {
    position: absolute;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: rgba(41, 47, 59, 0.8);
    display:flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    pointer-events: none;

    i {
      color: rgba(255, 255, 255, 0.25);
      font-size : 8rem;
    }
  }

  .info {
    .peer {
      padding: 16px 8px;

      &.screen-cast-item {
        padding: 8px 10px !important;
      }

      .display-name-container {
        display: flex;
        align-items: center;

        span {
          font-family: "Roboto", sans-serif;
          font-weight: 600;

          &.display-name {
            white-space: nowrap;
                display: flex;
                align-items: center;

            .name {
              display: flex;
              flex-direction: column;
            }
            .first-name {
              font-size:13px;
              font-weight: 600;
            }

            .title {
              font-size:11px;
              font-weight: 400;
            }

            i {
              color: #0baaa5;
              font-size: 16px;
              margin-right: 4px;
            }

            .screen-share-span {
              font-size: 13px !important;
              font-weight: 500;
              background: #0baaa5 !important;
              padding: 6px 8px;
              border-radius: 8px;
              color:white;
              margin-left: 4px;
            }
          }

          &.close-screenshare {
            cursor:pointer;
            font-size: 13px;
            font-weight: 500;
            background: #0baaa5;
            padding: 6px 8px;
            border-radius: 8px;
            color:white;
            margin-left: 4px;
            pointer-events: all;
          }
        }
      }
    }
  }
}

</style>




// WEBPACK FOOTER //
// src/components/media/PeerView/PeerView.vue